// extracted by mini-css-extract-plugin
module.exports = {"textCenter":"styles_textCenter__1EVKT","legend":"styles_legend__2_YD_","marginBottom":"styles_marginBottom__2vaWK"};